module.exports = __webpack_public_path__ + "img/brand-1.0b1e524b.png";